var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9601 2C19.4552 2 19.9308 2.19715 20.2805 2.54752C22.5765 4.8473 23.6337 5.95923 26.7891 9.88745C27.0546 10.2179 27.2 10.6309 27.2 11.0548V26.2667C27.2 28.3285 25.5285 30 23.4667 30H8.53332C6.47146 30 4.79999 28.3285 4.79999 26.2667V5.73333C4.79999 3.67147 6.47146 2 8.53332 2H18.9601ZM8.53332 3.86667C7.50239 3.86667 6.66665 4.7024 6.66665 5.73333V26.2667C6.66665 27.2976 7.50239 28.1333 8.53332 28.1333H23.4667C24.4976 28.1333 25.3333 27.2976 25.3333 26.2667V11.8985C25.3333 11.894 25.3333 11.8894 25.3333 11.8848V12.2667H19.7333C18.1869 12.2667 16.9333 11.0131 16.9333 9.46667V3.86667H8.53332ZM18.7999 4.03435V9.46667C18.7999 9.98213 19.2178 10.4 19.7333 10.4H24.6868C23.1493 8.26456 21.5397 6.61005 19.3469 4.41381C19.1873 4.25401 19.0017 4.12615 18.7999 4.03435ZM9.46665 16C8.95119 16 8.53332 16.4179 8.53332 16.9333C8.53332 17.4488 8.95119 17.8667 9.46665 17.8667H22.5333C23.0488 17.8667 23.4667 17.4488 23.4667 16.9333C23.4667 16.4179 23.0488 16 22.5333 16H9.46665ZM9.46665 22.5333C8.95119 22.5333 8.53332 22.9512 8.53332 23.4667C8.53332 23.9821 8.95119 24.4 9.46665 24.4H22.5333C23.0488 24.4 23.4667 23.9821 23.4667 23.4667C23.4667 22.9512 23.0488 22.5333 22.5333 22.5333H9.46665Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.978d8a07.svg";
export { ForwardRef as ReactComponent };